module.exports = __webpack_public_path__ + "static/tat-e9b827d3185c94046d008ca40b896e70.svg";